import type {
  Nullable,
  WorkflowSchema,
  WorkflowStep,
} from '~/core/shared/types';

export const getWorkflowStep = (
  workflowSchema: WorkflowSchema | undefined,
  place: string | undefined,
): Nullable<WorkflowStep> => {
  if (workflowSchema && place) {
    return workflowSchema.steps[place] || null;
  }

  return null;
};
